<div
  class="login-register"
  style="background-image: url(assets/images/background/login-register.jpg)"
>
  <div class="login-register-box">
    <mat-card>
      <mat-card-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="text-center">
            <img alt="homepage" src="assets/images/logo-icon.png" />
            <h4 class="m-t-0">Logar</h4>
          </div>

          <div fxLayout="row wrap">
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <mat-form-field>
                <input
                  matInput
                  placeholder="Usuário"
                  [formControl]="form.controls['uname']"
                />
              </mat-form-field>
              <small
                *ngIf="
                  form.controls['uname'].hasError('required') &&
                  form.controls['uname'].touched
                "
                class="text-danger support-text"
                >Usuário é obrigatório.</small
              >
            </div>
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <mat-form-field>
                <input
                  matInput
                  type="password"
                  placeholder="Senha"
                  [formControl]="form.controls['password']"
                />
              </mat-form-field>
              <small
                *ngIf="
                  form.controls['password'].hasError('required') &&
                  form.controls['password'].touched
                "
                class="text-danger support-text"
                >Senha é obrigatória.</small
              >
            </div>
            <!-- col half-->
            <div fxFlex.gt-sm="50" fxFlex.gt-xs="50">
              <mat-checkbox color="warn"
              [formControl]="form.controls['remember']">Lembrar</mat-checkbox>
            </div>
            <!-- col half-->
            <div fxFlex.gt-sm="50" fxFlex.gt-xs="50" class="text-right">
              <a [routerLink]="['/authentication/esqueci-senha']" class="link"
                >Esqueceu a senha?</a
              >
            </div>
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <button
                mat-raised-button
                color="primary"
                class="btn-block btn-lg m-t-20 m-b-20"
                type="submit"
                [disabled]="!form.valid"
              >
                Logar
              </button>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
